<div class="cus_det_tab_card cdtc_top_view">

    <h3 class="cdtc_title cdt_date_title cdt_trip_title">

        <span class="cdt_txt">

          {{DisplayAddTopSectionCurrentDate(this.currentDate)}}

            <span class="cdt_arrow">

                <a  id="prev" href="javascript:void(0)" class="cda_left" (click)="NextPrev(1)"><i class="icon-down_arrow_icon"></i></a>

                <a id="next" href="javascript:void(0)" class="cda_right" (click)="NextPrev(0)"><i class="icon-up_arrow_icon"></i></a>

            </span>

        </span>

        <a href="javascript:void(0)"  (click)="redirectListView()" class="cdt_tit_tag btn"><i class="icon-menu"></i></a>

    </h3>

</div>

<div class="calendar_view_card">
  <div class="calendar">
    <ul class="weeks">
      <li><span>S</span></li>
      <li><span>M</span></li>
      <li><span>T</span></li>
      <li><span>W</span></li>
      <li><span>T</span></li>
      <li><span>F</span></li>
      <li><span>S</span></li>

    </ul>
    <ul class="days">
      <ng-container *ngFor="let obj of this._json">
        <li (click)="ShowEventOnDateClick(obj)"
        [ngClass]="{ 'disable':obj.disable,'active_date':  obj.event?.length>0 ?obj.event[0]?.isverified==1 || obj.event[0].isholidayLeave==1:'', 'meetingDates': obj.meetingDates}"
          [ngStyle]="{'background-color':obj.event?.length>0 ?obj.event[0]?.backgroundColor:''}">
          <span class="cal_date">{{obj.value}}</span>

          <span *ngIf="obj.event?.length>0">
            <span *ngIf="obj.event[0].isverified==1 || obj.event[0].isholidayLeave==1" class=""
            [ngClass]="obj.event[0].isverified==1 ? 'cal_event_date ced_success' : obj.event[0].isholidayLeave==1 ? 'cal_event_date ced_holiday' : ''">
              <i class="icon-success"></i>
            </span>

            <!-- <span *ngIf="obj.event[0].plan_created_count>=0 && obj.event[0].planned_completed_count!='0/0'" class="cal_event_date">{{obj.event[0].planned_completed_count}} </span> -->
            <!-- <span *ngIf="obj.event[0].dot =='true'" class="cal_dot"><span>{{obj.event[0].dot}}</span></span> -->

            <!-- <span *ngIf="obj.event[0].star =='true'" class="cal_star">

              <svg enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24">
                <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27z"/>
              </svg>

            </span> -->

            <!-- <span class="cal_star" *ngIf="obj.event[0].star =='true'">
              <span class="star"><i></i></span>
            </span> -->

          </span>
          <!-- <span>{{obj.differntDays}}</span> -->
          <!-- <span *ngIf="obj.meetingDates">{{obj.meetingDates}} </span> -->

          <!-- <p *ngIf="obj.event?.length>0 && obj.event[0].event_type==2   ">
            {{obj.event[0].title=='Others' ? obj.event[0].extendedProps.data[0].title            :obj.event[0].title}}</p>
          <p *ngIf="obj.event?.length>0 &&  obj.event[0].event_type==1 ">
            <span>{{obj.event[0].week_name}} </span> {{obj.event[0].alt_name}}
            <ng-container *ngIf="obj.event[0].week_day==1">
              <i (click)="$event.stopPropagation();WeekPlanDown(obj)" class="icon-download"></i>
            </ng-container>
          </p> -->
          <!-- <span class="cl_day_dot" style="background-color: {{obj.event?.length>0 ?obj.event[0]?.backgroundColor:''}}"></span> -->
        </li>
      </ng-container>
    </ul>

    <!-- <div class="cale_mob_even_show">
      <ul>
        <ng-container *ngFor="let obj of this._json">
          <ng-container *ngIf="obj.cal_type==2">
            <li id="divf_{{obj.id }}" class="{{obj.class}}">
              <div *ngIf="obj.event?.length==0 ">
                <h4>{{obj.f_mob_ppdate}}</h4>
                <p>{{obj.f_day}}</p>
              </div>


              <div *ngIf="obj.event?.length>0 && obj.event[0].event_type==2   ">
                <h4>{{obj.f_mob_ppdate}} <span>{{obj.event[0].title}}</span></h4>
                <p
                  [ngStyle]="{'background-color':obj.event?.length>0 ?obj.event[0]?.backgroundColor:'','border-color':obj.event?.length>0 ?obj.event[0]?.backgroundColor:''}">

                  <span
                    [ngStyle]="{'background-color':obj.event?.length>0 ?obj.event[0]?.backgroundColor:'','border-color':obj.event?.length>0 ?obj.event[0]?.backgroundColor:''}"></span>

                  {{obj.event[0].extendedProps.data[0].title}}

                </p>
              </div>

              <div *ngIf="obj.event?.length>0 &&  obj.event[0].event_type==1 ">
                <h4>{{obj.f_mob_ppdate}} <span *ngIf="obj.event?.length>0">{{obj.event[0].week_name}}</span></h4>
                <p *ngIf="obj.event?.length>0 &&  obj.event[0].event_type==1 "
                  [ngStyle]="{'background-color':obj.event?.length>0 ?obj.event[0]?.backgroundColor:'','border-color':obj.event?.length>0 ?obj.event[0]?.backgroundColor:''}">

                  <span
                    [ngStyle]="{'background-color':obj.event?.length>0 ?obj.event[0]?.backgroundColor:'','border-color':obj.event?.length>0 ?obj.event[0]?.backgroundColor:''}"></span>

                  {{obj.event[0].alt_name}}

                </p>
                <ng-container *ngIf="obj.event[0].week_day==1">
                  <i (click)="$event.stopPropagation();WeekPlanDown(obj)" class="icon-download"></i>
                </ng-container>
              </div>

              <span class="cl_day_dot" style="background-color: {{obj.event?.length>0 ?obj.event[0]?.backgroundColor:''}}"></span>
            </li>
          </ng-container>
        </ng-container>
      </ul>

    </div> -->

  </div>


</div>
